import { render, staticRenderFns } from "./wait_give_point_box.vue?vue&type=template&id=52c5310f&scoped=true"
import script from "./wait_give_point_box.vue?vue&type=script&lang=js"
export * from "./wait_give_point_box.vue?vue&type=script&lang=js"
import style0 from "../assets/styles/todo-feedback.scss?vue&type=style&index=0&id=52c5310f&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_16d71e7cf8bf5c3e53d15d26d70867ca/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c5310f",
  null
  
)

export default component.exports